console.log('[PDP AntiCollapse v2] loaded');

(() => {
  const MQ = '(min-width: 990px)';
  const isDesktop = () => window.matchMedia(MQ).matches;

  const SUSPECT_SELECTORS = [
    '#MainContent',
    '#MainContent.content-for-layout',
    '#MainContent .shopify-section',
    '#MainContent .section-wrapper',
    '#MainContent .group-block-content',
    '#MainContent .layout-panel',
    '#MainContent .layout-panel-flex',
    '#MainContent .layout-panel-flex--column'
  ].join(', ');

  function fixEl(el) {
    if (!el) return;

    const cs = getComputedStyle(el);
    const rect = el.getBoundingClientRect();

    const collapsed = rect.height === 0 || cs.height === '0px' || cs.maxHeight === '0px';
    const hidden = cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0';
    const offscreen = cs.transform && cs.transform !== 'none' && /translate|matrix/.test(cs.transform);

    if (collapsed) {
      el.style.height = 'auto';
      el.style.minHeight = '1px';
      el.style.maxHeight = 'none';
      el.style.overflow = 'visible';
    }

    // Para el contenedor principal, dale piso real
    if (el.id === 'MainContent') {
      el.style.minHeight = '100vh';
      el.style.height = 'auto';
      el.style.overflow = 'visible';
    }

    if (hidden) {
      el.style.display = 'block';
      el.style.visibility = 'visible';
      el.style.opacity = '1';
    }

    // Si alguna animación lo manda fuera, lo neutralizamos (solo si está “apagando” el layout)
    if (offscreen && (collapsed || hidden)) {
      el.style.transform = 'none';
    }
  }

  function runOnce() {
    if (!isDesktop()) return;

    const nodes = document.querySelectorAll(SUSPECT_SELECTORS);
    nodes.forEach(fixEl);

    // Extra: si algún inline style trae height:0, lo reparamos
    document.querySelectorAll('#MainContent [style*="height:0"], #MainContent [style*="height: 0"]').forEach(fixEl);
  }

  // Corre por ráfagas durante los primeros segundos (cuando suele “desaparecer”)
  function burst() {
    runOnce();
    setTimeout(runOnce, 150);
    setTimeout(runOnce, 350);
    setTimeout(runOnce, 700);
    setTimeout(runOnce, 1200);
    setTimeout(runOnce, 2000);
    setTimeout(runOnce, 3500);
  }

  // Observa TODO el body porque Fabric/apps pueden reemplazar #MainContent
  const bodyObs = new MutationObserver(() => {
    // Si hay cambios grandes, volvemos a corregir
    runOnce();
  });

  function start() {
    if (!isDesktop()) return;
    burst();
    bodyObs.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class'] });

    // Fallback duro: intervalo corto por si algo sigue colapsando sin mutaciones detectables
    let ticks = 0;
    const iv = setInterval(() => {
      if (!isDesktop()) return;
      runOnce();
      ticks++;
      if (ticks > 40) clearInterval(iv); // ~20s y se apaga
    }, 500);
  }

  window.addEventListener('DOMContentLoaded', start);
  window.addEventListener('load', start);
})();
